import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { WhatsNew } from 'src/app/shared/models/whats-new.interface';

@Component({
  selector: 'app-dialog-whats-new',
  templateUrl: './dialog-whats-new.component.html',
  styleUrls: ['./dialog-whats-new.component.scss'],
})
export class DialogWhatsNewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WhatsNew,
    private dialogRef: MatDialogRef<DialogWhatsNewComponent>,
  ) {}

  categoryLabel(category: string): string {
    switch (category) {
      case 'new':
        return 'New';
      case 'improved':
        return 'Improved';
      default:
        return 'Fixed';
    }
  }

  categoryIcon(category: string): string {
    switch (category) {
      case 'new':
        return 'rocket_launch';
      case 'improved':
        return 'trending_up';
      default:
        return 'build';
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
